import axios from 'axios'

const SET_IMPORTS = 'SET_IMPORTS'
const RESET = 'RESET'

const BASE_URL = 'api/Services/Ingestions'
const CHECK_FILE_FORMAT = `${BASE_URL}/CheckFileFormat`
const INGESTION_RESULTS_URL = `${BASE_URL}/GetIngestionResults`
const INGEST_FILE_URL = `${BASE_URL}/IngestFileData`

const initialState = () => ({
  ingestionResults: [],
  importIds: [],
  importsIndex: {},
})

export default {
  namespaced: true,
  state: initialState(),
  actions: {
    async checkFileFormat(_, {
      rdrFileId,
      rdrFileIds,
    }) {
      try {
        let response = await axios.post(CHECK_FILE_FORMAT, {
          rdrFileIds: rdrFileIds || [rdrFileId],
        })

        return response.data
      } catch (error) {
        throw error.response.data
      }
    },
    async ingestFiles(_, {
      rdrFileId,
      rdrFileIds,
      skipCheckFileFormat,
    }) {
      try {
        let response = await axios.post(INGEST_FILE_URL, {
          rdrFileIds: rdrFileIds || [rdrFileId],
          params: {
            skipCheckFileFormat,
          },
        }, {timeout: 1000 * 60 * 30})

        return response.data
      } catch (error) {
        throw error.response.data
      }
    },
    async fetchIngestionResults({
      commit,
    }, {
      startDate,
      endDate,
      searchText,
      executionId,
    }) {
      try {
        let response = await axios.post(INGESTION_RESULTS_URL, {
          filterParams: {
            startDate,
            endDate,
            searchText,
            executionId,
          },
        })

        let ingestionResults = response.data
        let importIds = ingestionResults.ImportIds
        let importsIndex = ingestionResults.ImportsIndex

        commit('SET_IMPORTS', { importIds, importsIndex })
        return ingestionResults
      } catch (error) {
        console.error(error)
        throw error.response.data
      }
    },
  },
  mutations: {
    [SET_IMPORTS](state, { importIds, importsIndex }) {
      state.importIds = importIds
      state.importsIndex = importsIndex
    },
    [RESET](state) {
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
  },
}